module.exports = __webpack_public_path__ + "img/ClientePreferencial.1de9cb8a.png";